<template>
	<div class="aside-wrap">
		<div class="user-aside">
			<div class="userinfo" @click="toDetail()">
				<!-- <img :src="item.headPic" /> -->
				<img :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
				<span class="username">{{item.nickName}}</span>
			</div>
			<div class="user-num-wrap">
				<div class="user-num-list">
					<span class="num-amount">{{item.followNum}}</span>
					<span class="num-item">关注</span>
				</div>
				<div class="user-num-list">
					<span class="num-amount">{{item.fansNum}}</span>
					<span class="num-item">粉丝</span>
				</div>
				<div class="user-num-list">
					<span class="num-amount">{{item.postNum}}</span>
					<span class="num-item">动态</span>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import userInfoModules from '@/modules/userInfo.js'
	export default {
		name: 'userAside',
		components: {
			
		},
		props: {
			id: {
				type: Number,
				value: ''
			}
		},
		data(){
			return {
				followUserId: '',
				userId: '',  //登录用户id
				item: {}
			}
		},
		mixins: [
			userInfoModules
		],
		watch: {
			id:{
				handler(newVal) {
					this.followUserId = newVal
					if(this.followUserId){
						this.getUserInfo()
					}
					
				},
				immediate:true
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')||''
		},
		methods: {
			toDetail(){
				this.$router.push({
					path: '/userIndex?id='+this.item.id
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.aside-wrap{
		height: 274px;
		background-color: #fff;
	}
	.user-aside{
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 40px 0;
		box-sizing: border-box;
		.userinfo{
			display: flex;
			flex-direction: column;
			align-items: center;
			img{
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}
			.username{
				display: block;
				margin: 12px 0 5px;
				font-size: 20px;
				font-weight: bold;
			}
			.userinfo-tips{
				display: block;
				font-size: 12px;
				color: var(--color-text-opacity);
			}
		}
		.user-num-wrap{
			display: flex;
			justify-content: space-around;
			flex: 1;
			margin-top: 20px;
			.user-num-list{
				display: flex;
				flex-direction: column;
				align-items: center;
				border-right: 1px solid var(--color-border);
				flex:1;
			}
			.user-num-list:nth-of-type(3){
				border-right: none;
			}
		}
	}
</style>
